export default __webpack_public_path__ + "static/media/ada.0e9b088b.svg";